<template>
    <b-modal
        :id="modalId"
        modal-class="custom-modal"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="area-modal">
            <div class="content-modal">
                <div
                    class="header"
                    v-html="lbl.home.seeDetailModal.title"
                ></div>
                <div class="list-detail">
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 1 :
                        </div>
                        <div class="detail-item-text">
                            กล้อง LEICA Q2 Black มูลค่า 179,200 บาท จำนวน 2
                            รางวัล มูลค่ารวม 358,400 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-1@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 2 :
                        </div>
                        <div class="detail-item-text">
                            Ipad Pro รุ่น 12.9 นิ้ว พร้อม Wifi + Cellular 1TB
                            มูลค่า 57,400 บาท จำนวน 3 รางวัล มูลค่ารวม 172,200
                            บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-2@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 3 :
                        </div>
                        <div class="detail-item-text">
                            ลำโพง JBL BAR 5.1 มูลค่า 40,000 บาท จำนวน 3 รางวัล
                            มูลค่ารวม 120,000 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-3@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 4 :
                        </div>
                        <div class="detail-item-text">
                            สกู๊ตเตอร์ไฟฟ้า รุ่น MAX จาก Segway Ninebot มูลค่า
                            29,900 บาท จำนวน 3 รางวัล มูลค่ารวม 89,700 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-4@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 5 :
                        </div>
                        <div class="detail-item-text">
                            เครื่องดูดฝุ่น Dyson รุ่น V11 Absolute+ มูลค่า
                            27,900 บาท จำนวน 3 รางวัล มูลค่ารวม 83,700 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-5@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 6 :
                        </div>
                        <div class="detail-item-text">
                            เครื่องฟอกอากาศ Dyson รุ่น Pure Cool™ air purifier
                            tower fan TP04 มูลค่า 27,900 บาท จำนวน 3 รางวัล
                            มูลค่ารวม 83,700 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-6@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 7 :
                        </div>
                        <div class="detail-item-text">
                            เครื่องชงกาแฟ Nespresso รุ่น Creatista Plus Metal
                            Stainless Steel พร้อมกาแฟแคปซูล 1 กล่อง มูลค่า 26,000
                            บาท จำนวน 5 รางวัล มูลค่ารวม 130,000 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-7@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 8 :
                        </div>
                        <div class="detail-item-text">
                            ลำโพง Marshall รุ่น Stanmore II Voice with Google
                            Assistant มูลค่า 19,900 บาท จำนวน 3 รางวัล มูลค่ารวม
                            59,700 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-8@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 9 :
                        </div>
                        <div class="detail-item-text">
                            ชุดอุปกรณ์จัดแต่งทรงผม Dyson รุ่น Airwrap Complete
                            มูลค่า 17,900 บาท จำนวน 3 รางวัล มูลค่ารวม 53,700
                            บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-9@2x.png" />
                        </div>
                    </div>
                    <div class="list-detail-item">
                        <div class="detail-item-header">
                            รางวัลที่ 10 :
                        </div>
                        <div class="detail-item-text">
                            กล้อง GoPro รุ่น Max มูลค่า 17,000 บาท จำนวน 3
                            รางวัล มูลค่ารวม 51,000 บาท
                        </div>
                        <div class="detail-item-img">
                            <img src="@/assets/megaWish/Artwork/aw-10@2x.png" />
                        </div>
                    </div>
                </div>
                <div class="bottom-modal">
                    <div
                        class="btn-close"
                        v-html="lbl.home.seeDetailModal.btnClose"
                        @click="hide"
                    >
                        ปิด
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ListGiftModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl()
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./modal.scss";
.area-modal {
    .content-modal {
        background-color: #87030c;
    }
}
</style>
